import {useRef} from "react";
import {useAnalyticsTrackers} from "./useAnalyticsTrackers";
import {useAppSelector} from "../store/hooks";
import {selectReleaseToggles} from "../ReleaseToggles/releaseTogglesSlice";

export const useMeetingTimer = () => {
    const startRef = useRef<number | null>(null);
    const pauseIntervalsRef = useRef<Array<{ pause: number; resume: number | null }>>([]);
    const releaseToggles = useAppSelector(selectReleaseToggles);

    const {page} = useAnalyticsTrackers();

    const startMeeting = () => {
        if (releaseToggles?.enableGoogleAnalytics) {
            startRef.current = Date.now();
            pauseIntervalsRef.current = [];
        }

    };

    const pauseMeeting = () => {
        if (releaseToggles?.enableGoogleAnalytics) {
            pauseIntervalsRef.current.push({pause: Date.now(), resume: null});
        }
    };

    const resumeMeeting = () => {

        if (releaseToggles?.enableGoogleAnalytics) {
            const last = pauseIntervalsRef.current[pauseIntervalsRef.current.length - 1];
            if (last && last.resume === null) {
                last.resume = Date.now();
            }
        }
    };

    const endMeeting = () => {

        if (releaseToggles?.enableGoogleAnalytics) {
            const endRefTime = Date.now();

            let pausedTime = 0;
            pauseIntervalsRef.current.forEach(({pause, resume}) => {
                pausedTime += (resume ?? endRefTime) - pause;
            });

            if (startRef.current && endRefTime) {
                const totalDuration = (endRefTime - startRef.current - pausedTime) / 1000;

                page("Client_Meeting_Duration", {
                    cd4_duration: totalDuration,
                    cd3_inMeeting: true
                });

                console.log("Meeting ended, duration tracked.");
            }
            startRef.current = null;
            pauseIntervalsRef.current = [];
        }
    };

    return {startMeeting, pauseMeeting, resumeMeeting, endMeeting};
};